import { render } from "./PhotoGalleryCard.vue?vue&type=template&id=140ab652&scoped=true"
import script from "./PhotoGalleryCard.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryCard.vue?vue&type=script&lang=js"

import "./PhotoGalleryCard.vue?vue&type=style&index=0&id=140ab652&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140ab652"]])

export default __exports__